import React, { Fragment } from "react";
import BracketMatchBox from "../Match/BracketMatchBox.jsx";
import BracketTeamPublic from "../Match/BracketTeamPublic.jsx";
import BracketTeamAdmin from "../Match/BracketTeamAdmin.jsx";
import BracketGameDetails from "../Match/BracketGameDetails.jsx";

export default function BracketRounds({
  bracketData,
  games,
  matchRefs,
  matchTops,
  readOnly,
  slug,
  navigate,
  division,
  setSelectedMatchup,
  setIsCreateModalOpen,
  draggedTeam,
  setDraggedTeam,
  setBracketData,
  fetchGames,
  setGames,
  isTeamAlreadyPlaced,
  gameHasScore,
  setEditGame,
  setIsEditModalOpen,
  handleDeleteGame,
  colorScheme,
  gameDetailsTextColor,
}) {
  return bracketData.rounds.map((round, roundIndex) => (
    <div
      key={roundIndex}
      className="bracket-display-column"
      style={{
        position: "relative",
        minWidth: 200,
        flex: 1,
      }}
    >
      {round.map((match, matchIndex) => {
        const topValue =
          matchTops[roundIndex]?.[matchIndex];

        // Round 1 BYEs are not visually rendered
        if (roundIndex === 0 && match.isBye) {
          return null;
        }

        // Invisible structural spacer
        if (roundIndex === 0 && match.isSpacer) {
          return (
            <div
              key={match.matchId}
              style={{
                position: "absolute",
                top: topValue,
                width: "100%",
                visibility: "hidden",
              }}
            />
          );
        }

        // Don't render until this match has a calculated position
        if (typeof topValue !== "number") {
          return null;
        }

        const existingGame = games.find(
          (g) => g.match_id === match.matchId
        );

        return (
          <Fragment key={match.matchId}>
            <BracketGameDetails
              existingGame={existingGame}
              topValue={topValue}
              gameDetailsTextColor={gameDetailsTextColor}
            />

            <BracketMatchBox
              match={match}
              existingGame={existingGame}
              readOnly={readOnly}
              slug={slug}
              navigate={navigate}
              division={division}
              onCreate={
                readOnly
                  ? undefined
                  : (m) => {
                    setSelectedMatchup(m);
                    setIsCreateModalOpen(true);
                  }
              }
              topValue={topValue}
              matchIndex={matchIndex}
              matchRefs={matchRefs}
              colorScheme={colorScheme}
            >
              {match.isBye ? (
                `${match.teamA?.name || match.teamB?.name || "BYE"}`
              ) : readOnly ? (
                <BracketTeamPublic
                  match={match}
                  existingGame={existingGame}
                />
              ) : (
                <BracketTeamAdmin
                  match={match}
                  existingGame={existingGame}
                  games={games}
                  draggedTeam={draggedTeam}
                  setDraggedTeam={setDraggedTeam}
                  division={division}
                  bracketData={bracketData}
                  setBracketData={setBracketData}
                  fetchGames={fetchGames}
                  setGames={setGames}
                  isTeamAlreadyPlaced={isTeamAlreadyPlaced}
                  gameHasScore={gameHasScore}
                  setEditGame={setEditGame}
                  setIsEditModalOpen={setIsEditModalOpen}
                  handleDeleteGame={handleDeleteGame}
                  readOnly={readOnly}
                />
              )}
            </BracketMatchBox>
          </Fragment>
        );
      })}
    </div>
  ));
}